"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductHeadOptionsContextProvider = exports.useProductHeadOptions = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var ProductHeadOptionsContext = /*#__PURE__*/_react["default"].createContext();
var ProductHeadOptionsContextProvider = function ProductHeadOptionsContextProvider(props) {
  var _useState = (0, _react.useState)(null),
    activeProduct = _useState[0],
    setActiveProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    activePicker = _useState2[0],
    setActivePicker = _useState2[1];
  var updateActiveProduct = function updateActiveProduct(product) {
    setActiveProduct(product);
  };
  var updateActivePicker = function updateActivePicker(product) {
    setActivePicker(product);
  };
  return __jsx(ProductHeadOptionsContext.Provider, {
    value: {
      updateActiveProduct: updateActiveProduct,
      activeProduct: activeProduct,
      activePicker: activePicker,
      updateActivePicker: updateActivePicker
    }
  }, props.children);
};
exports.ProductHeadOptionsContextProvider = ProductHeadOptionsContextProvider;
var useProductHeadOptions = function useProductHeadOptions() {
  return (0, _react.useContext)(ProductHeadOptionsContext);
};
exports.useProductHeadOptions = useProductHeadOptions;
var _default = ProductHeadOptionsContextProvider;
exports["default"] = _default;